import React from 'react';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';

export default function ContactInfoSection({ sectionTitle }) {
  return (
    <section className="bg-cream py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-16">
        <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
          <span className="w-[24px] h-px bg-gold block"></span>
          Contact Us
        </div>
        <h2 className="font-serif text-4xl md:text-[3.5rem] font-light leading-[1.2] text-charcoal mb-16">
          {sectionTitle || "Get in Touch"}
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Details */}
          <div>
            <div className="bg-white p-8 md:p-12 rounded-md shadow-sm border border-cream-dark h-full">
              <h3 className="font-serif text-2xl text-charcoal mb-8">Abuja Office</h3>
              <div className="space-y-6">
                <IconBoxStyle11
                  title="Phone"
                  subTitle="+234 803 873 8245"
                  iconSrc="/images/contact/icon_1.svg"
                  show={true}
                />
                <IconBoxStyle11
                  title="Email"
                  subTitle="contact@nooohraservices.org"
                  iconSrc="/images/contact/icon_2.svg"
                  show={true}
                />
                <IconBoxStyle11
                  title="Location"
                  subTitle="First Floor, Sterling Bank Plaza, Central Business District, Abuja, 900103"
                  iconSrc="/images/contact/icon_3.svg"
                  show={true}
                />
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="h-full min-h-[400px] rounded-md overflow-hidden shadow-sm border border-cream-dark">
            <iframe
              id="map"
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.157130466655!2d7.4793307750661295!3d9.049428091012716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0ba0804de4f7%3A0xb3d30461278f9586!2sSterling%20Bank%20plaza!5e0!3m2!1sen!2sng!4v1734280474311!5m2!1sen!2sng"
              className="w-full h-full min-h-[400px] border-0"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
